import script from "./OHoras.vue?vue&type=script&lang=ts&setup=true"
export * from "./OHoras.vue?vue&type=script&lang=ts&setup=true"

import "./OHoras.vue?vue&type=style&index=0&id=89dd24da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89dd24da"]])

export default __exports__